import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 引入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 引入Bootstrap样式
import 'bootstrap/dist/css/bootstrap.min.css'
// 导入全局样式
import './assets/css/style.css'
// 引入Bootstrap JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// 引入AOS动画库
import AOS from 'aos'
import 'aos/dist/aos.css'

// 引入粒子背景
import Particles from 'vue3-particles'

// Lottie动画
import { Vue3Lottie } from 'vue3-lottie'
// 移除CSS导入，因为vue3-lottie不需要额外的CSS文件

const app = createApp(App)

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册全局组件
app.use(Particles)
app.component('Vue3Lottie', Vue3Lottie)

app.use(router)
app.use(ElementPlus)

// 初始化AOS
AOS.init({
  duration: 1000,
  easing: 'ease-in-out',
  once: true,
  mirror: false
})

app.mount('#app')
